import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { getEffectiveFieldMode, useFieldMode } from './FieldModeContext';
import { isAdminSettingsPath } from '../components/layout/navLinks';

/**
 * When an admin has field mode on, only admin Settings (and PDF studio) stay on admin URLs.
 * All other /admin/* routes redirect to the technician dashboard.
 */
export default function FieldModeGuard({
  children
}: {
  children: React.ReactNode;
}): React.JSX.Element {
  const { user, loading } = useAuth();
  const { fieldMode } = useFieldMode();
  const location = useLocation();

  if (loading) {
    return <>{children}</>;
  }

  const role = typeof user?.role === 'string' ? user.role.trim().toLowerCase() : '';
  const effectiveFieldMode = getEffectiveFieldMode(fieldMode);

  if (
    role === 'admin' &&
    effectiveFieldMode &&
    location.pathname.startsWith('/admin') &&
    !isAdminSettingsPath(location.pathname)
  ) {
    return <Navigate to="/technician/dashboard" replace />;
  }

  return <>{children}</>;
}
